/* eslint-disable */
import PropTypes from 'prop-types';

/**
 * Convert an Object of action creators to PropTypes
 * @export
 * @param {any} actionCreators The action creators to convert
 * @returns {Object} The converted action creators
 */
const propsActionCreatorsToPropTypes = (actionCreators) => {
  return Object.keys(actionCreators).reduce((prev, next) => {
    return {
      ...prev,
      [next]: PropTypes.func.isRequired,
    };
  }, {});
};

export default propsActionCreatorsToPropTypes;
